import { useEffect }  from "react";
import '../../../App.css';
import './Sculc-2022.css';

import AOS from 'aos';
import 'aos/dist/aos.css';

const Sculc2022Presentation = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="sculc2022-page">
            <div className="sculc2022-header-container">
                <img
                    src="/images/balloons-clouds-word-clouds-abstract-dialogue-discussion-talk-graphic-background.jpg"
                    alt="Header"
                    className="sculc2022-header-image"
                />  
                <h1 className="sculc2022-title">Presentations</h1>
            </div>
            <div className="sculc2022-navbar">
                <div className="sculc2022-navbar-container">
                    <a href="/sculc-2022" className="sculc2022-links">Home</a>
                    <a href="/sculc-2022-program" className="sculc2022-links">Programs</a>
                    <a href="/sculc-2022-presentation" className="sculc2022-links">Presentations</a>
                    <a href="/sculc-2022-photo" className="sculc2022-links">Photos</a>
                </div>
            </div>
            <div className="sculc2022-container">
                <div className="sculc2022-table-container">
                    <div className="sculc2022-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="0">
                        <img src="/images/sculc2022/SCULC-logo-square.png"
                            alt="Sculc-logo"
                            className="sculc2022-logos"
                            style={{width: "100%"} }></img>
                        <p><i>Presenters are arranged in order of presentations according to the program. To view our program, click the program tab in the right corner.</i></p>
                    </div>
                    <div className="sculc2022-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="200" >
                        <iframe loading="lazy" src="https://drive.google.com/file/d/11p6HftEcaKVMk93AqGj0VaONN704Hqxa/preview" width="100%" allow="autoplay" title="presentation" style={{ aspectRatio: "1/1" }}></iframe>
                        <p className="sculc2022-presenter-name">Aliya Glatt</p>
                        <p>University of California, Los Angeles</p>
                    </div>
                    <div className="sculc2022-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="400">
                        <iframe loading="lazy" src="https://drive.google.com/file/d/1mJzXBzOKBDEtulj2eqw_cjkQpoaehbLf/preview" width="100%" allow="autoplay" title="presentation" style={{ aspectRatio: "1/1" }}></iframe>
                        <p className="sculc2022-presenter-name">Yadi Peng</p>
                        <p>University of Washington</p>
                    </div>
                </div>
                <div className="sculc2022-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="0">
                    <iframe loading="lazy" src="https://drive.google.com/file/d/13dpJ8o95hOVrhBQEpYNxJQU5PinA05y6/preview" width="100%" allow="autoplay" title="presentation" style={{ aspectRatio: "16/9" }}></iframe>
                </div>
                <div className="sculc2022-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="200">
                    <iframe loading="lazy" src="https://drive.google.com/file/d/1-i8miRozjfqghDBGAtDZ0yi81NHuxnQI/preview" width="100%" allow="autoplay" title="presentation" style={{ aspectRatio: "16/9" }}></iframe>
                </div>
                <div data-aos="fade-up" data-aos-once="true" data-aos-delay="0" style={{width:"100%", margin: "1em"} }>
                    <p className="sculc2022-presenter-name"> Penelope Hurtado-Stuart & Carson Collins</p>
                    <p>University of Arizona</p>
                </div>
                <div className="sculc2022-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="0">
                    <iframe loading="lazy" src="https://docs.google.com/presentation/d/e/2PACX-1vRsPfh9DmoT7hc8CFn9F0DHZxICL0vUAnvVhwjJsksbnxUpi-BYYUEMk6riO07UzcqtS5oLbO8nTUl9/embed?start=false&loop=false&delayms=60000" frameborder="0" width="100%" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" title="presentation" style={{ aspectRatio: "1/1" }}></iframe>
                    <p className="sculc2022-presenter-name">Jean-Max Fawzi</p>
                    <p>University of California, Los Angeles</p>
                </div>
                <div className="sculc2022-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="200">
                    <iframe loading="lazy" src="https://drive.google.com/file/d/1397rvGfMK3DTgYXwN1ekx5kUxZ8HskoS/preview" width="100%" allow="autoplay" title="presentation" style={{ aspectRatio: "1/1" }}></iframe>
                    <p style={{ textAlign: "center", fontSize: "1.8em", color: "#4499cc", lineHeight: "1.6em" }}>Asheeyah Fatima Bantuas & Shahanie Sarip</p>
                    <p>Mindanao State University</p>
                </div>
                <div className="sculc2022-table-presentation" data-aos="fade-up" data-aos-once="true" data-aos-delay="400">
                    <iframe loading="lazy" src="https://drive.google.com/file/d/1whJHXQLrXL3Jgvf_r9qaGfRFHZ-ZaAU2/preview" width="100%" allow="autoplay" title="presentation" style={{ aspectRatio: "1/1" }}></iframe>
                    <p className="sculc2022-presenter-name">Yizhuo Zhang</p>
                    <p>Beijing Foreign Studies University</p>
                </div>
                
            </div>
            <div className="sculc2022-container" style={{ width: "50%", marginLeft: "25%" }} data-aos="fade-up" data-aos-once="true" >
                <img src="./images/sculc2022/SCULC-2022-Thank-you.png" alt="Thank you note" className="sculc2022-thank-you-note"></img>
            </div>

            <div style={{ height: "5vh" }}></div> {/* bottom spacing */}
            
                
        </div>
    );
};

export default Sculc2022Presentation;
